<template>
 <div class="bg-[#23242A] text-white px-6 pt-6 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto">
    <div :class="'flex content-main gap-5 ' + (action.component ? ' half-it' : '')">
      <div class="custom-full">
        <Nav/>
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]">
          <block-loading v-if="loading"/>
          <template v-else>
            <template v-if="hasLoyaltyProgramAndCategory">
              <div class="mb-3 flex justify-between">
                <h3 class="text-[24px] text-white font-semibold">FAQ</h3>
                <div class="flex">
                  <button v-if="can_edit_membership_details" @click.prevent="syncConfirm.modal = true" class="bg-white boder border-theme-green rounded px-4 mr-3 text-theme-green hover:text-white hover:bg-theme-green">RESET FAQ</button>
                  <mdicon @click="addUpdate({ component: 'Add', data: {} })" v-if="!action.component && can_edit_membership_details" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
                </div>
              </div>
              <List :selectedCallback="selectedItem" :loyaltyProgram="loyaltyProgram" :faqCategory="faqCategory" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/> 
            </template>
            <div v-else class="bg-[#2B2C32] border-0 rounded-lg">
              <div class="mb-3 flex justify-between">
                <h3 class="text-[20px] text-theme-878686 font-bold tracking-wider">F.A.Q</h3>
              </div>
              <p class="text-sm"> Loyalty Program is inactive or not set.</p>
            </div>
          </template>
        </div>
      </div>
      <div :class="'w-full hidden-component'" v-if="action.component" >
        <component :is="action.component" :loyaltyProgram="loyaltyProgram" :faqCategory="faqCategory" :item="action.data" :clearComponent="clearComponent"></component>
      </div>
    </div>

    
    <custom-modal :size="'max-w-2xl'" v-if="syncConfirm.modal">
      <template v-slot:maincontent>
        <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden w-full">
          <div class=" bg-[#464851] px-[16px] py-[16px] rounded-lg">
            <div class="flex justify-center relative gap-3 pb-5">
              <div class="text-2xl font-normal tracking-wide text-center pr-[40px]">Are you sure you want to reset the FAQ?</div>
              <a href="" class="right-0 top-1 absolute" @click.prevent="syncConfirm.modal = false"><mdicon size="30px" class="cursor-pointer hover:text-slate-200 " name="close"/></a>
            </div>
            <div class="px-[16px] py-[16px] bg-[#2B2C32] rounded-xl">  
              <div class="flex flex-col justify-center">
                <p class="text-sm text-center leading-5 tracking-wider">By confirming this action, you will be resetting your FAQ to default questions and answers. This action is irreversible and you won’t be able to recover your existing questions and answers</p>
                <div class="flex justify-center mt-4">
                  <button @click.prevent="syncfaqs()" class="uppercase rounded-lg bg-theme-green hover:bg-theme-darkgreen text-white min-w-[320px] py-[14px] text-sm tracking-wider font-medium">confirm</button>
                </div>
              </div>
            </div>
            <div class=" flex justify-center items-center pt-[10px]">
              <button  @click.prevent="syncConfirm.modal = false" class="uppercase text-sm font-medium tracking-widest text-white hover:text-theme-green">Close</button>
            </div>
          </div>
        </div> 
      </template>
    </custom-modal>


  </div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import LoyaltyProgramApis from "@/controllers/LoyaltyProgramApis";
import LoyaltyFaqApis from "@/controllers/LoyaltyFaqApis";
import LoyaltyFaqCategoryApis from "@/controllers/LoyaltyFaqCategoryApis";

import List from '@/views/Membership/Program/Faqs/List.vue';
import Add from '@/views/Membership/Program/Faqs/Add.vue';
import Update from '@/views/Membership/Program/Faqs/Update.vue';
import Nav from "@/views/Membership/Program/Nav.vue";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';

  export default defineComponent({
  name: "FaqIndex",
  components: {
    Nav,
    List,
    Add,
    Update,
    
  },

  setup() {
    const hasLoyaltyProgramAndCategory = ref(false);
    const loading = ref(false);
    const loyaltyProgram = <any>ref({});
    const faqCategory = <any>ref({});
    const action = ref<object>({
      component: '',
      data: {},
    });
    const syncConfirm = ref({
      modal: false,
    })
    const snackbar = useSnackbar();
    return {
      snackbar,
      hasLoyaltyProgramAndCategory,
      action,
      loading,
      loyaltyProgram,
      faqCategory,
      syncConfirm
    };
  },


  watch : {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {
    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },

    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  async mounted() {
    this.loading = true;
    // first get program details, if not available create
    await this.getProgramAndCategory();
    // first get categories, if not available create
    this.loading = false;
    
  },

  beforeDestroy() {
  
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    /**
     * Get program and category
     */
    async getProgramAndCategory() {
      let loyaltyProgramRes = await LoyaltyProgramApis.getProgramByCurrentActiveBusiness();
      if(loyaltyProgramRes.status == 200 || loyaltyProgramRes.status == 201) {
         this.loyaltyProgram = loyaltyProgramRes.data;
         // Now category 
        let loyaltyFaqCategoryRes = await LoyaltyFaqCategoryApis.getAll(loyaltyProgramRes.data.id);
        if(loyaltyFaqCategoryRes.status == 200) {
          if(loyaltyFaqCategoryRes.data.total_results > 0) {
            this.faqCategory = loyaltyFaqCategoryRes.data.results[0];
            this.hasLoyaltyProgramAndCategory = true;
          }
        } else {
          let loyaltyFaqCategoryCreateRes = await LoyaltyFaqCategoryApis.create(this.loyaltyProgram.id, {
            name: loyaltyProgramRes.data.name + ' Faq Category',
            desc: "Frequently asked questions",
            sort_order: 1
          });
          if(loyaltyFaqCategoryCreateRes == 201) {
            this.faqCategory = loyaltyFaqCategoryCreateRes.data;
            this.hasLoyaltyProgramAndCategory = true;
          }
        }
      }
    },

    /**
     * syncFaq return confirm modal
     */
     async syncfaqs() {
  
      this.va_spinner(true);
      let res = await LoyaltyFaqApis.sync(this.loyaltyProgram.id, this.faqCategory.id, this.loyaltyProgram.name);

      if(res.status == 201) {
        this.emitter.emit("refresh-faqs-list", true);
      }
      this.syncConfirm.modal = false

      this.snackbar.add({
        type: 'info',
        text: (res.status == 201 || res.status == 200) ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })

      this.va_spinner(false);

     },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>


